import useFeatureFlag from './useFeatureFlag'

export default useFeatureFlag
